<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <span v-if="props.column.field === 'customerMediate'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.appointmentCustomerDateStr }} {{ props.row.appointmentCustomerStartTime}} - {{ props.row.appointmentCustomerEndTime }} </span>
          </br>
          <span class="text-nowrap">{{ props.row.customerMediateStr }}</span>
        </span>
        
        <span v-if="props.column.field === 'companyMediate'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.appointmentCompanyDateStr }} {{ props.row.appointmentCompanyStartTime}} - {{ props.row.appointmentCompanyEndTime }} </span>
          </br>
          <span class="text-nowrap">{{ props.row.companyMediateStr }}</span>
        </span>

        <span v-if="props.column.field === 'groupName'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.groupName }} </span>
        </span>


        
        <!-- Column: Name -->
        <span v-if="props.column.field === 'committeeStatus'" class="text-nowrap">
          <span class="text-nowrap">{{
            committeeStatusText(props.row.committeeStatus)
          }}</span>
        </span>
        <!-- Column: Name -->
        <span v-if="props.column.field === 'updateDate'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.updateDateStr }}</span>
        </span>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item @click="onManageBtnClicked(props.row.id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>แก้ไข</span>
              </b-dropdown-item>
              <!-- <b-dropdown-item                
                @click="onDeleteBtnClicked(props.row.id)"
              >
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>ลบ</span>
              </b-dropdown-item> -->
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              limit="8"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import TableHeaders from "./commonTableHeader.js";
import * as subcommitteeStore from "@/store/api/subcommittee/index.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns:TableHeaders,
      rows: [],
      searchTerm: "",
      totalRecords: 0,
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    this.onSearchSubmit({});
  },
  methods: {
    committeeStatusText(statusId) {
      if (statusId === 1) {
        return "รอการอนุมัติ";
      } else if (statusId === 2) {
        return "อนุมัติแล้ว";
      }else {
        return "รอสร้างจดหมายเชิญ";
      }
    },
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params);
    },
    onSearchSubmit(params, page = { currentPage: 1 }) {
      //console.log('onSearchSubmit', params)

      params.userActive = userData.userId();
      params.page = page.currentPage;
      params.perPage = this.pageLength;
      this.$emit("handleOverlay", true);

      var _this = this;
      subcommitteeStore
        .getMeetingList(params)
        .then(function(response) {
          // handle success
          console.log("then response", response);
          _this.rows = response.data.data;
          console.log("result _this.rows", _this.rows);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          console.log("GET");
          _this.$emit("handleOverlay", false);
        });
    },
    onManageBtnClicked(id) {
      window.open(
        this.$router.resolve({ name: "SubCommitteeInvitationManage", query: { id } }).href,
        "_blank"
      );
    },
    onDeleteBtnClicked(id) {
      const _this = this;

      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          // subcommitteeStore
          //   .deleteItem(id)
          //   .then((response) => {
          //     if (response.data.success === true) {
          //       this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
          //         title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
          //         variant: "success",
          //         solid: false,
          //       });

          //       this.onSearchSubmit({});
          //     } else {
          //       _this.$bvToast.toast("เกิดข้อผิดพลาด", {
          //         title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
          //         variant: "danger",
          //         solid: false,
          //       });
          //     }
          //   })
          //   .catch((error) => {
          //     console.log("error", error);
          //     _this.$bvToast.toast("เกิดข้อผิดพลาด", {
          //       title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
          //       variant: "danger",
          //       solid: false,
          //     });
          //   });
        }
      });
    },
    onComplainSend(id) {
      this.$emit("handleSend", id);
    },
    onComplainGroupManage(id) {
      this.$emit("handleGroup", id);
    },
    confirmText() {
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "ลบข้อมูล สำเร็จ",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
